import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { IStorageLocal } from "namirasoft-core";
import { SecretCreateRow, SecretRow, SecretUpdateRow } from "namirasoft-secret";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, IDFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { SecretMenus } from "./SecretMenus";
import { SecretRouterProps } from "./SecretRouterProps";
import { SecretRoutes } from "./SecretRoutes";

export class SecretEntities
{
	static secret(props: NSARouterMakerResult & SecretRouterProps, retreive_value_handler: (id: string) => void): IEntityInfo<SecretRow, SecretCreateRow | SecretUpdateRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_SECRET,
			name: "secret",
			tables: [{ table: namirasoft.secret.tables.secret, required: true }],
			client: {
				getListURL: () => SecretRoutes.SecretList,
				getNewURL: () => SecretRoutes.SecretNew,
				getCopyURL: (id: string) => SecretRoutes.SecretCopy(id),
				getEditURL: (id: string) => SecretRoutes.SecretEdit(id),
				getViewURL: (id: string) => SecretRoutes.SecretView(id),
				getMenus: (getIDs, getRows) => { return { "Value": [SecretMenus.RetrieveValue(getIDs, getRows, retreive_value_handler)] } },
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.group, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.algorithm, new EnumFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.secret.tables.secret.columns.updated_at, new DateTimeFormatter())
					];
				},
			},
			server: {
				value_list: props.servers.secret.value.List,
				get: props.servers.secret.secret.Get,
				list: props.servers.secret.secret.List,
				create: async (entity: SecretCreateRow | SecretUpdateRow) =>
				{
					return props.servers.secret.secret.Create(entity as any);
				},
				update: async (id: string, entity: SecretCreateRow | SecretUpdateRow) =>
				{
					let e = entity as any;
					delete e.value;
					delete e.algorithm;
					return props.servers.secret.secret.Update(id, e);
				},
				delete: props.servers.secret.secret.Delete
			}
		}
	}
}